// import feedbackList from '../components/feedback/feedbackList.vue'

export default [
    { 
        path: 'feedback/feedbackList',
        component: resolve => require(['@/components/feedback/feedbackList'],resolve),
        name:'feedbackList',
        meta:{
            id:'938',
            node:'feedback',
            url:'feedbackList',
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/feedback.js